import { create } from 'zustand';

import type { AtamaOzeti, EtkinYetki, GirisKullanicisi } from '../api/kimlik';

/**
 * OTURUM DURUMU.
 *
 * ERİŞİM JETONU BURADA TUTULMAZ; `api/jeton-deposu.ts` içindedir. Jeton bir
 * arayüz durumu değildir ve React DevTools'ta görünmemelidir.
 */

/**
 * `kuruluyor` — açılışta çerezle oturum geri kurulmaya çalışılıyor.
 *   Bu aşamada yönlendirme YAPILMAZ; aksi halde sayfa her yenilendiğinde
 *   kullanıcı bir an giriş ekranını görür.
 * `kisitli` — oturum açık ama ilk giriş kısıtı var: şifre değiştirilmeli
 *   ya da aydınlatma onaylanmalı. Panel açılırsa kullanıcı boş bir arayüze
 *   düşer ve her istek 403 alır.
 */
export type OturumAsamasi = 'kuruluyor' | 'anonim' | 'kisitli' | 'acik';

interface OturumDurumu {
  asama: OturumAsamasi;
  kullanici: GirisKullanicisi | null;
  yetkiler: EtkinYetki[];
  /**
   * YETKİLER SUNUCUDAN GELDİ Mİ.
   *
   * `yetkiler` boş dizi İKİ ANLAMA gelir: "henüz gelmedi" ve "gerçekten
   * yetkisi yok". Ayrım yapılmazsa, başlangıç durumunu yetkiye bağlayan bir
   * ekran (`PuantajDenetimi` sekmesi) doğrudan adrese F5 atıldığında yanlış
   * sekmede açılır — `/kimlik/ben` daha dönmemişken karar verilmiştir.
   * Sorguların `enabled` koşulu da bu bayrağı beklemeli; beklemezse yetkisi
   * olan kullanıcı için gereksiz bir istek gider ya da hiç gitmez.
   */
  yetkilerYuklendiMi: boolean;
  /** İşlem yapılan atama. Birden çok atamalı kullanıcıda seçilebilir. */
  etkinAtama: AtamaOzeti | null;
  /*
   * DERİN BAĞLANTIYA DÖNÜŞ (hedefYol) BÖLÜM 2'YE BIRAKILDI.
   *
   * Bölüm 1'de tek ekran var; dönülecek bir yol yok. Alan şimdiden
   * tutulsaydı yazılır ama hiç okunmazdı — yarım bağlanmış durum, hiç
   * olmayandan daha yanıltıcıdır.
   */

  kullaniciyiYaz: (kullanici: GirisKullanicisi) => void;
  yetkileriYaz: (yetkiler: EtkinYetki[]) => void;
  dustu: () => void;
}

/**
 * İlk giriş kısıtlarının ikisi de çözülmeden panel açılmaz.
 *
 * Sunucu bunu zaten dayatıyor (403 SIFRE_DEGISTIRILMELI /
 * AYDINLATMA_ONAYI_GEREKLI); burada tekrarlanması kullanıcıyı her isteği
 * reddedilen boş bir ekrandan korumak içindir.
 */
function asamaHesapla(kullanici: GirisKullanicisi): OturumAsamasi {
  if (kullanici.sifreDegistirmeliMi) return 'kisitli';
  if (!kullanici.aydinlatmaOnayliMi) return 'kisitli';
  return 'acik';
}

export const oturumDeposuKullan = create<OturumDurumu>((ata) => ({
  asama: 'kuruluyor',
  kullanici: null,
  yetkiler: [],
  yetkilerYuklendiMi: false,
  etkinAtama: null,

  kullaniciyiYaz: (kullanici) =>
    ata({
      kullanici,
      asama: asamaHesapla(kullanici),
      // Varsayılan atama BİRİNCİL olandır; bordroya esas olan odur. Yoksa
      // ilk atama, o da yoksa null kalır ve atama gerektiren ekranlar uyarır.
      etkinAtama: kullanici.atamalar.find((a) => a.birincilMi) ?? kullanici.atamalar[0] ?? null,
    }),

  yetkileriYaz: (yetkiler) => ata({ yetkiler, yetkilerYuklendiMi: true }),

  dustu: () =>
    ata({
      asama: 'anonim',
      kullanici: null,
      yetkiler: [],
      // Bayrak da SIFIRLANIR: aynı tarayıcıda giriş yapan ikinci kullanıcı
      // için yetkiler yeniden çekilene dek "yüklendi" sayılmamalı.
      yetkilerYuklendiMi: false,
      etkinAtama: null,
    }),
}));
